export const AI_DEFAULT_MAX_QUERY_LIMIT = 1000;
